import { apiFetch } from '@/lib/api';

export interface UsageTotals {
  calls: number; input_tokens: number; output_tokens: number;
  total_tokens: number; cost_usd: number; success_rate: number;
}
export interface UsageByModel { model: string; provider: string; calls: number; total_tokens: number; cost_usd: number; }
export interface UsageByKind { kind: string; calls: number; total_tokens: number; cost_usd: number; }
export interface UsageTrendPoint { day: string; tokens: number; cost_usd: number; }
export interface AiUsage {
  days: number;
  totals: UsageTotals;
  trend: UsageTrendPoint[];
  by_model: UsageByModel[];
  by_kind: UsageByKind[];
}

export function getAiUsage(days: number): Promise<AiUsage> {
  return apiFetch<AiUsage>(`/ai-usage?days=${days}`);
}
